// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-home[data-v-67ebb1c1]{height:100%;padding:calc(var(--default-grid-baseline)*4)}`, "",{"version":3,"sources":["webpack://./src/views/Home.vue"],"names":[],"mappings":"AACA,+BACC,WAAA,CACA,4CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
